import _ from 'lodash';

import {startSubmit, stopSubmit} from 'redux-form';

import {delay} from 'redux-saga';
import {call, takeLatest, put, all, select} from 'redux-saga/effects';

import {getErrors} from 'utils/errors';
import {getWarnings} from 'utils/warnings';
import {storeDataInModal} from 'ducks/modals';
import {MODALS} from 'ducks/tenancy';
import {MODALS as BASE_MODALS} from 'ducks/modals';

import {
  request,
  createFetchSagaLatest,
  createPostSagaLatest
} from 'utils/sagas';

import {
  FETCH_GC_PAYMENT_DELAY,
  fetchTenancy as fetchTenancyAction,
  fetchRentSchedule as fetchRentScheduleAction,
  fetchDepositSchedule as fetchDepositScheduleAction,
  fetchOneOffSchedule as fetchOneOffScheduleAction,
  fetchInvoice as fetchInvoiceAction,
  fetchDraftInvoice as fetchDraftInvoiceAction,
  fetchCreditNote as fetchCreditNoteAction,
  fetchPayment as fetchPaymentAction,
  fetchXeroTaxRates as fetchXeroTaxRatesAction,
  fetchRoomAllocations as fetchRoomAllocationsAction,
  fetchOverpayment as fetchOverpaymentAction,
  fetchXeroOrganisation as fetchXeroOrganisationAction,
  fetchBreakClause as fetchBreakClauseAction,
  fetchXeroAccounts as fetchXeroAccountsAction,
  fetchTerminationReasons as fetchTerminationReasonsAction,
  fetchGocardlessCustomer as fetchGocardlessCustomerAction,
  fetchGocardlessCustomerPayments as fetchGocardlessCustomerPaymentsAction,
  fetchGocardlessPayment as fetchGocardlessPaymentAction,
  fetchGocardlessPaymentEventsHistory as fetchGocardlessPaymentEventsHistoryAction,
  fetchEarlyTerminations as fetchEarlyTerminationsAction,
  fetchCanCreateFinanceItemForPastMonths as fetchCanCreateFinanceItemForPastMonthsAction,
  addPayment as addPaymentAction,
  addRefund as addRefundAction,
  getNextFreeIdCounter as getNextFreeIdCounterAction,
  createInvoice as createInvoiceAction,
  createDraftInvoice as createDraftInvoiceAction,
  createCreditNote as createCreditNoteAction,
  createOverpayment as createOverpaymentAction,
  addRefundForOverpayment as addRefundForOverpaymentAction,
  voidObject as voidObjectAction,
  addXeroId as addXeroIdAction,
  syncWithXero as syncWithXeroAction,
  roomMove as roomMoveAction,
  moveEntireBooking as moveEntireBookingAction,
  getMoveRoomOverlap as getMoveRoomOverlapAction,
  predictTermination as predictTerminationAction,
  confirmTermination as confirmTerminationAction,
  deleteEarlyTermination as deleteEarlyTerminationAction,
  RECORD_BREAK_CLAUSE_NOTICE,
  recordBreakClauseNoticeSuccess,
  recordBreakClauseNoticeFailure,
  INITIATE_GOCARDLESS_PAYMENT,
  initiateGocardlessPaymentSuccess,
  initiateGocardlessPaymentFailure,
  ROOM_MOVE_FLOW,
  CANCEL_GOCARDLESS_PAYMENT,
  cancelGocardlessPaymentSuccess,
  cancelGocardlessPaymentFailure,
  RETRY_GOCARDLESS_PAYMENT,
  retryGocardlessPaymentSuccess,
  retryGocardlessPaymentFailure,
  selectBookingRoomTypeRef,
  fetchNextPossibleChargeDate as fetchNextPossibleChargeDateAction,
  fetchGocardlessCustomerAndInvitation as fetchGocardlessCustomerAndInvitationAction,
  REMOVE_GOCARDLESS_INVITATION,
  removeGocardlessInvitationSuccess,
  removeGocardlessInvitationFailure,
  REMOVE_GOCARDLESS_CUSTOMER,
  removeGocardlessCustomerSuccess,
  removeGocardlessCustomerFailure,
  VOID_GOCARDLESS_INVITATION_WARNINGS,
  voidGocardlessInvitationWarningsSuccess,
  voidGocardlessInvitationWarningsFailure,
  fetchGoCardlessTenantsForBooking as fetchGoCardlessTenantsForBookingAction,
  FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS,
  fetchSendGoCardlessInvitationWarningsSuccess,
  fetchSendGoCardlessInvitationWarningsFailure,
  SEND_GOCARDLESS_INVITATION,
  sendGoCardlessInvitationSuccess,
  sendGoCardlessInvitationFailure,
  FILTER_GOCARDLESS_CUSTOMERS,
  filterGoCardlessCustomersSuccess,
  filterGoCardlessCustomersFailure,
  FILTER_GOCARDLESS_ACTIVE_MANDATES,
  filterGoCardlessActiveMandatesSuccess,
  filterGoCardlessActiveMandatesFailure,
  FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS,
  fetchLinkGoCardlessMandateToBookingWarningsSuccess,
  fetchLinkGoCardlessMandateToBookingWarningsFailure,
  CONNECT_GOCARDLESS_CUSTOMER,
  connectGoCardlessCustomerSuccess,
  connectGoCardlessCustomerFailure,
  fetchSuggestedGoCardlessCustomersAndInvitations as fetchSuggestedGoCardlessCustomersAndInvitationsAction,
  ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING,
  attachGoCardlessCustomerToBookingSuccess,
  attachGoCardlessCustomerToBookingFailure,
  ATTACH_GOCARDLESS_INVITATION_TO_BOOKING,
  attachGoCardlessInvitationToBookingSuccess,
  attachGoCardlessInvitationToBookingFailure,
  cancelGocardlessCustomer as cancelGocardlessCustomerAction,
  cancelGocardlessCustomerWarnings as cancelGocardlessCustomerWarningsAction,
  deallocateCreditNotes as deallocateCreditnotesAction,
  fetchInvoiceAllocatedCreditNotesXeroLinks as fetchInvoiceAllocatedCreditNotesXeroLinksAction,
  deallocateCreditNoteFromInvoice as deallocateCreditNoteFromInvoiceAction,
  deleteDraftInvoice as deleteDraftInvoiceAction,
  approveDraftInvoice as approveDraftInvoiceAction
} from './';
import {
  fetchTenancy,
  fetchSchedule,
  fetchInvoice,
  fetchDraftInvoice,
  addPayment,
  fetchCreditNote,
  addRefund,
  fetchPayment,
  getNextFreeIdCounter,
  fetchXeroAccounts,
  fetchRoomAllocations,
  fetchXeroTaxRates,
  roomMove,
  findAllocation,
  createInvoice,
  createDraftInvoice,
  fetchOverpayment,
  fetchXeroOrganisation,
  createCreditNote,
  addRefundForOverpayment,
  createOverpayment,
  voidObject,
  addXeroId,
  syncWithXero,
  recordBreakClauseNotice,
  fetchBreakClause,
  fetchTerminationReasons,
  fetchGocardlessCustomer,
  fetchGocardlessCustomerPayments,
  initiateGocardlessPayment,
  fetchGocardlessPayment,
  fetchGocardlessPaymentEventsHistory,
  fetchCanCreateFinanceItemForPastMonths,
  predictTermination,
  filterGocardlessCustomers,
  filterGocardlessActiveMandates,
  confirmTermination,
  cancelGocardlessPayment,
  retryGocardlessPayment,
  moveEntireBooking,
  fetchEarlyTerminations,
  getMoveRoomOverlap,
  deleteEarlyTermination,
  fetchNextPossibleChargeDate,
  fetchGocardlessCustomerAndInvitation,
  removeGocardlessInvitation,
  removeGocardlessCustomer,
  voidGocardlessInvitationWarnings,
  fetchGoCardlessTenantsForBooking,
  fetchSendGoCardlessInvitationWarnings,
  sendGoCardlessInvitation,
  fetchLinkGoCardlessMandateToBookingWarnings,
  connectGoCardlessCustomer,
  fetchSuggestedGoCardlessCustomersAndInvitations,
  attachGoCardlessCustomerToBooking,
  attachGoCardlessInvitationToBooking,
  cancelGocardlessCustomer,
  cancelGocardlessCustomerWarnings,
  deallocateCreditNotes,
  fetchInvoiceAllocatedCreditNotesXeroLinks,
  deallocateCreditNoteFromInvoice,
  deleteDraftInvoice,
  approveDraftInvoice
} from 'sdk/tenancy';

import {fetchRoomTypes, fetchAvailableRooms} from 'sdk/rooms';

function* roomMoveFlow(action) {
  const {
    payload: {
      locationRef,
      bookingId,
      startDate,
      startHour,
      endDate,
      modalName,
      cleanupPeriodDays
    }
  } = action;
  let {roomType} = action;

  try {
    if (_.isNil(roomType)) {
      const fetchRoomTypesResponse = yield call(fetchRoomTypes, {locationRef});
      const roomTypes = fetchRoomTypesResponse.data;
      yield put(storeDataInModal({modalName, data: {roomTypes: roomTypes}}));

      const state = yield select();
      roomType = selectBookingRoomTypeRef(state);
    }

    const findAllocationResponse = yield call(findAllocation, {
      locationRef,
      bookingId: bookingId,
      startingPoint: startDate,
      startingHour: startHour
    });

    const currentRoomAllocation = findAllocationResponse.data;

    yield put(
      storeDataInModal({
        modalName,
        data: {
          currentRoomAllocation
        }
      })
    );

    const availableRoomsResponse = yield call(fetchAvailableRooms, {
      locationRef,
      roomType,
      startDate,
      startHour,
      endDate,
      cleanupPeriodDays
    });

    const availableRooms = availableRoomsResponse.data;
    yield put(
      storeDataInModal({
        modalName,
        data: {
          newRooms: availableRooms
        }
      })
    );
  } catch (error) {
    let errors;

    if (error.response.status === 400) {
      errors = getErrors(error.response.data);
    }

    yield* [put(stopSubmit('roomMove', errors))];
    return;
  }
}

function* recordBreakClauseNoticeWorker(action) {
  const {successExtraActions, failureExtraActions} = action.payload;

  try {
    yield put(startSubmit('breakClauseNoticeRecord'));

    const {data} = yield call(recordBreakClauseNotice, action.payload);

    yield stopSubmit('breakClauseNoticeRecord');
    yield recordBreakClauseNoticeSuccess(data);

    yield* successExtraActions.map(a => put(a()));
  } catch (error) {
    let errors, warnings;

    if (error.response.status === 400) {
      const data = error.response.data;

      if (_.get(data, 'errors')) {
        errors = getErrors(data);
      }
      if (_.get(data, 'warnings')) {
        warnings = {
          data: getWarnings(data.warnings),
          meta: data.warnings
        };
      }
    }

    yield put(stopSubmit('breakClauseNoticeRecord', errors));
    yield put(recordBreakClauseNoticeFailure(error));

    yield* failureExtraActions.map(a => put(a(warnings)));
  }
}

function* initiateGocardlessPaymentWorker(action) {
  yield put(startSubmit('initiateGoCardlessPaymentForm'));

  const {data, errors} = yield request(
    initiateGocardlessPayment,
    action.payload
  );

  if (data) {
    yield* [put(initiateGocardlessPaymentSuccess(data))].concat(
      action.payload.extraActions.map(extraAction => put(extraAction()))
    );
    yield put(
      storeDataInModal({
        modalName: MODALS.INVOICE_DETAIL,
        data: {loading: true}
      })
    );

    yield call(delay, FETCH_GC_PAYMENT_DELAY);

    const invoiceResponse = yield call(fetchInvoice, action.payload);

    yield put(
      storeDataInModal({
        modalName: MODALS.INVOICE_DETAIL,
        data: {
          invoice: invoiceResponse.data,
          loading: false
        }
      })
    );
  }

  if (errors) {
    yield put(stopSubmit('initiateGoCardlessPaymentForm', errors));
    yield put(initiateGocardlessPaymentFailure(errors));
  }
}

function* cancelGocardlessPaymentWorker(action) {
  const {errors} = yield request(cancelGocardlessPayment, action.payload);

  if (!errors) {
    yield put(cancelGocardlessPaymentSuccess());
    yield* action.payload.extraActions.map(extraAction => put(extraAction()));
  }

  if (errors) {
    yield put(cancelGocardlessPaymentFailure());
    yield put(
      storeDataInModal({
        modalName: BASE_MODALS.CONFIRM,
        data: {errors, submitting: false}
      })
    );
  }
}

function* retryGocardlessPaymentWorker(action) {
  const {errors} = yield request(retryGocardlessPayment, action.payload);

  if (!errors) {
    yield put(retryGocardlessPaymentSuccess());
    yield* action.payload.extraActions.map(extraAction => put(extraAction()));
  }

  if (errors) {
    yield put(retryGocardlessPaymentFailure());
    yield put(
      storeDataInModal({
        modalName: BASE_MODALS.CONFIRM,
        data: {errors, submitting: false}
      })
    );
  }
}

function* removeGocardlessInvitationWorker(action) {
  const {data, errors} = yield request(
    removeGocardlessInvitation,
    action.payload
  );

  if (data) {
    yield put(removeGocardlessInvitationSuccess(data));
    yield* action.payload.successExtraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(removeGocardlessInvitationFailure(errors));
    yield* action.payload.failureExtraActions.map(a => put(a(errors)));
  }
}

function* removeGocardlessCustomerWorker(action) {
  const {data, errors} = yield request(
    removeGocardlessCustomer,
    action.payload
  );

  if (data) {
    yield put(removeGocardlessCustomerSuccess(data));
    yield* action.payload.successExtraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(removeGocardlessCustomerFailure(errors));
    yield* action.payload.failureExtraActions.map(a => put(a(errors)));
  }
}

function* voidGocardlessInvitationWarningsWorker(action) {
  const {data, errors} = yield request(
    voidGocardlessInvitationWarnings,
    action.payload
  );

  if (data) {
    yield put(voidGocardlessInvitationWarningsSuccess(data));
    yield* action.payload.extraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(voidGocardlessInvitationWarningsFailure(errors));
  }
}

function* fetchSendGoCardlessInvitationWarningsWorker(action) {
  const {
    tenancyId,
    tenantId,
    successExtraActions,
    failureExtraActions
  } = action.payload;

  const {data, errors} = yield request(fetchSendGoCardlessInvitationWarnings, {
    tenancyId,
    tenantId
  });

  if (data) {
    yield put(fetchSendGoCardlessInvitationWarningsSuccess(data));
    yield* successExtraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(fetchSendGoCardlessInvitationWarningsFailure(errors));
    yield* failureExtraActions.map(a => put(a(errors)));
  }
}

function* sendGoCardlessInvitationWorker(action) {
  const {
    tenancyId,
    tenantId,
    successExtraActions,
    failureExtraActions
  } = action.payload;

  const {data, errors} = yield request(sendGoCardlessInvitation, {
    tenancyId,
    tenantId
  });

  if (data) {
    yield put(sendGoCardlessInvitationSuccess(data));
    yield* successExtraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(sendGoCardlessInvitationFailure(errors));
    yield* failureExtraActions.map(a => put(a(errors)));
  }
}

function* filterGoCardlessCustomersWorker(action) {
  yield put(
    storeDataInModal({
      modalName: MODALS.SETUP_GOCARDLESS,
      data: {
        loadingGoCardlessCustomers: true
      }
    })
  );

  const {data, errors} = yield request(
    filterGocardlessCustomers,
    action.payload
  );

  if (data) {
    yield put(filterGoCardlessCustomersSuccess());
    yield* action.payload.extraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(filterGoCardlessCustomersFailure());
  }

  yield put(
    storeDataInModal({
      modalName: MODALS.SETUP_GOCARDLESS,
      data: {
        loadingGoCardlessCustomers: false
      }
    })
  );
}

function* filterGoCardlessActiveMandatesWorker(action) {
  const {data, errors} = yield request(
    filterGocardlessActiveMandates,
    action.payload
  );

  if (data) {
    yield put(filterGoCardlessActiveMandatesSuccess());
    yield* action.payload.extraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(filterGoCardlessActiveMandatesFailure());
  }
}

function* fetchLinkGoCardlessMandateToBookingWarningsWorker(action) {
  const {data, errors} = yield request(
    fetchLinkGoCardlessMandateToBookingWarnings,
    action.payload
  );

  if (data) {
    yield put(fetchLinkGoCardlessMandateToBookingWarningsSuccess());
    yield* action.payload.extraActions.map(a => put(a(data)));
  }

  if (errors) {
    yield put(fetchLinkGoCardlessMandateToBookingWarningsFailure());
  }
}

function* connectGoCardlessCustomerWorker(action) {
  yield put(startSubmit('goCardlessCustomerConnect'));

  const {data, errors} = yield request(
    connectGoCardlessCustomer,
    action.payload
  );

  if (data) {
    yield* action.payload.extraActions.map(a => put(a()));
    yield put(stopSubmit('goCardlessCustomerConnect'));
    yield put(connectGoCardlessCustomerSuccess());
  }

  if (errors) {
    yield put(stopSubmit('goCardlessCustomerConnect', errors));
    yield put(connectGoCardlessCustomerFailure());
  }
}

function* attachGoCardlessCustomerToBookingWorker(action) {
  const {data, errors} = yield request(
    attachGoCardlessCustomerToBooking,
    action.payload
  );

  if (data) {
    yield* action.payload.extraActions.map(a => put(a()));
    yield put(attachGoCardlessCustomerToBookingSuccess(data));
  }

  if (errors) {
    yield put(attachGoCardlessCustomerToBookingFailure(errors));
  }
}

function* attachGoCardlessInvitationToBookingWorker(action) {
  const {data, errors} = yield request(
    attachGoCardlessInvitationToBooking,
    action.payload
  );

  if (data) {
    yield* action.payload.extraActions.map(a => put(a()));
    yield put(attachGoCardlessInvitationToBookingSuccess(data));
  }

  if (errors) {
    yield put(attachGoCardlessInvitationToBookingFailure(errors));
  }
}

export function* tenancyDetailSaga() {
  yield all([
    createFetchSagaLatest(fetchTenancyAction, fetchTenancy),
    createFetchSagaLatest(fetchRentScheduleAction, fetchSchedule),
    createFetchSagaLatest(fetchDepositScheduleAction, fetchSchedule),
    createFetchSagaLatest(fetchOneOffScheduleAction, fetchSchedule),
    createFetchSagaLatest(fetchInvoiceAction, fetchInvoice),
    createFetchSagaLatest(fetchDraftInvoiceAction, fetchDraftInvoice),
    createFetchSagaLatest(fetchCreditNoteAction, fetchCreditNote),
    createFetchSagaLatest(fetchPaymentAction, fetchPayment),
    createFetchSagaLatest(fetchXeroAccountsAction, fetchXeroAccounts),
    createFetchSagaLatest(fetchXeroTaxRatesAction, fetchXeroTaxRates),
    createFetchSagaLatest(fetchRoomAllocationsAction, fetchRoomAllocations),
    createFetchSagaLatest(fetchOverpaymentAction, fetchOverpayment),
    createFetchSagaLatest(fetchXeroOrganisationAction, fetchXeroOrganisation),
    createFetchSagaLatest(fetchBreakClauseAction, fetchBreakClause),
    createFetchSagaLatest(
      fetchTerminationReasonsAction,
      fetchTerminationReasons
    ),
    createFetchSagaLatest(
      fetchGocardlessCustomerAction,
      fetchGocardlessCustomer
    ),
    createFetchSagaLatest(
      fetchGocardlessCustomerPaymentsAction,
      fetchGocardlessCustomerPayments
    ),
    createFetchSagaLatest(fetchGocardlessPaymentAction, fetchGocardlessPayment),
    createFetchSagaLatest(
      fetchGocardlessPaymentEventsHistoryAction,
      fetchGocardlessPaymentEventsHistory
    ),
    createFetchSagaLatest(fetchEarlyTerminationsAction, fetchEarlyTerminations),
    createFetchSagaLatest(
      fetchSuggestedGoCardlessCustomersAndInvitationsAction,
      fetchSuggestedGoCardlessCustomersAndInvitations
    ),
    createFetchSagaLatest(
      fetchNextPossibleChargeDateAction,
      fetchNextPossibleChargeDate
    ),
    createFetchSagaLatest(
      fetchGocardlessCustomerAndInvitationAction,
      fetchGocardlessCustomerAndInvitation
    ),
    createFetchSagaLatest(
      fetchGoCardlessTenantsForBookingAction,
      fetchGoCardlessTenantsForBooking
    ),
    createFetchSagaLatest(
      fetchInvoiceAllocatedCreditNotesXeroLinksAction,
      fetchInvoiceAllocatedCreditNotesXeroLinks
    ),
    createPostSagaLatest(
      fetchCanCreateFinanceItemForPastMonthsAction,
      fetchCanCreateFinanceItemForPastMonths
    ),
    createPostSagaLatest(addPaymentAction, addPayment),
    createPostSagaLatest(addRefundAction, addRefund),
    createPostSagaLatest(getNextFreeIdCounterAction, getNextFreeIdCounter),
    createPostSagaLatest(createInvoiceAction, createInvoice),
    createPostSagaLatest(createDraftInvoiceAction, createDraftInvoice),
    createPostSagaLatest(createCreditNoteAction, createCreditNote),
    createPostSagaLatest(createOverpaymentAction, createOverpayment),
    createPostSagaLatest(
      addRefundForOverpaymentAction,
      addRefundForOverpayment
    ),
    createPostSagaLatest(voidObjectAction, voidObject),
    createPostSagaLatest(deallocateCreditnotesAction, deallocateCreditNotes),
    createPostSagaLatest(
      deallocateCreditNoteFromInvoiceAction,
      deallocateCreditNoteFromInvoice
    ),
    createPostSagaLatest(deleteDraftInvoiceAction, deleteDraftInvoice),
    createPostSagaLatest(approveDraftInvoiceAction, approveDraftInvoice),
    createPostSagaLatest(addXeroIdAction, addXeroId),
    createPostSagaLatest(syncWithXeroAction, syncWithXero),
    createPostSagaLatest(roomMoveAction, roomMove),
    createPostSagaLatest(moveEntireBookingAction, moveEntireBooking),
    createPostSagaLatest(getMoveRoomOverlapAction, getMoveRoomOverlap),
    createPostSagaLatest(predictTerminationAction, predictTermination),
    createPostSagaLatest(confirmTerminationAction, confirmTermination),
    createPostSagaLatest(deleteEarlyTerminationAction, deleteEarlyTermination),

    takeLatest(RECORD_BREAK_CLAUSE_NOTICE, recordBreakClauseNoticeWorker),
    takeLatest(INITIATE_GOCARDLESS_PAYMENT, initiateGocardlessPaymentWorker),
    takeLatest(ROOM_MOVE_FLOW, roomMoveFlow),
    takeLatest(CANCEL_GOCARDLESS_PAYMENT, cancelGocardlessPaymentWorker),
    takeLatest(RETRY_GOCARDLESS_PAYMENT, retryGocardlessPaymentWorker),
    takeLatest(REMOVE_GOCARDLESS_INVITATION, removeGocardlessInvitationWorker),
    takeLatest(REMOVE_GOCARDLESS_CUSTOMER, removeGocardlessCustomerWorker),
    takeLatest(
      VOID_GOCARDLESS_INVITATION_WARNINGS,
      voidGocardlessInvitationWarningsWorker
    ),
    takeLatest(
      FETCH_SEND_GOCARDLESS_INVITATION_WARNINGS,
      fetchSendGoCardlessInvitationWarningsWorker
    ),
    takeLatest(SEND_GOCARDLESS_INVITATION, sendGoCardlessInvitationWorker),
    takeLatest(FILTER_GOCARDLESS_CUSTOMERS, filterGoCardlessCustomersWorker),
    takeLatest(
      FILTER_GOCARDLESS_ACTIVE_MANDATES,
      filterGoCardlessActiveMandatesWorker
    ),
    takeLatest(
      FETCH_LINK_GOCARDLESS_MANDATE_TO_BOOKING_WARNINGS,
      fetchLinkGoCardlessMandateToBookingWarningsWorker
    ),
    takeLatest(CONNECT_GOCARDLESS_CUSTOMER, connectGoCardlessCustomerWorker),
    takeLatest(
      ATTACH_GOCARDLESS_CUSTOMER_TO_BOOKING,
      attachGoCardlessCustomerToBookingWorker
    ),
    takeLatest(
      ATTACH_GOCARDLESS_INVITATION_TO_BOOKING,
      attachGoCardlessInvitationToBookingWorker
    ),
    createPostSagaLatest(
      cancelGocardlessCustomerAction,
      cancelGocardlessCustomer
    ),
    createPostSagaLatest(
      cancelGocardlessCustomerWarningsAction,
      cancelGocardlessCustomerWarnings
    )
  ]);
}
